<template>
  <span class="ux-circle" :style="style" />
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    style() {
      const color = this.value?.color;
      const bgColor = this.value?.bgColor;

      if (color || bgColor) {
        return {
          backgroundColor: bgColor || color,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-circle {
  width: 0.8em;
  height: 0.8em;
  display: inline-block;
  border-radius: 100%;
  background: color-mix(in lab, currentColor 20%, transparent);
  margin: 0 0.5px;
}
</style>
